<div class="modal-header">
    <h3 class="modal-title">Send Email Reminder </h3>
</div>
<div class="modal-body">
    <div class="card card-header border bg-light" style="margin-top:15px;">
        Employees with unsubmitted expenses
    </div>
    <div *ngIf="ReminderEmailList?.length > 0">
        <div style="max-height:200px; overflow-y:auto;">
            <table class="table">
                <thead>
                    <tr>
                        <th>
                            <a [href]="" (click)="sortGridReminder('Employee')" class="blacktext" style="cursor:pointer">
                                Employee
                                <span style="margin-left:5px;" *ngIf="filterBy === 'Employee' && reverse"><i class="modus-icons align-bottom">expand_less_bold</i></span>
                                <span style="margin-left:5px;" *ngIf="filterBy === 'Employee' && !reverse"><i class="modus-icons align-bottom">expand_more_bold</i></span>
                            </a>
                        </th>
                        <th>
                            <a [href]="" (click)="sortGridReminder('FirstName')" class="blacktext" style="cursor:pointer">
                                Name
                                <span style="margin-left:5px;" *ngIf="filterBy === 'FirstName' && reverse"><i class="modus-icons align-bottom">expand_less_bold</i></span>
                                <span style="margin-left:5px;" *ngIf="filterBy === 'FirstName' && !reverse"><i class="modus-icons align-bottom">expand_more_bold</i></span>
                            </a>
                        </th>
                        <th>
                            <a [href]="" (click)="sortGridReminder('Email')" class="blacktext" style="cursor:pointer">
                                Email
                                <span style="margin-left:5px;" *ngIf="filterBy === 'Email' && reverse"><i class="modus-icons align-bottom">expand_less_bold</i></span>
                                <span style="margin-left:5px;" *ngIf="filterBy === 'Email' && !reverse"><i class="modus-icons align-bottom">expand_more_bold</i></span>
                            </a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of ReminderEmailList">
                        <td>{{data.Employee}}</td>
                        <td>{{data.FirstName}} {{data.LastName}}</td>
                        <td>{{data.Email}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <br />
</div>

<div class="modal-footer">
    {{counter}} recipients will be notified.
    <button type="button" class="btn btn-primary" (click)="reminderClicked()">Send Reminder</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>